import React from 'react';
import PropTypes from 'prop-types';

const Impersonate = ({ color = '#8C949C' }) => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="Svg-Icons/18px-(All-icons)/impersonate"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <path
                d="M15,4 L17,4 L14,8 L11,4 L13,4 L13,2 L6,2 L6,5 L4,5 L4,1.64313008e-14 L15,1.64313008e-14 L15,4 Z M10,16.3082707 C10,14.7315789 12.6685714,13.9398496 14,13.9398496 C15.3314286,13.9398496 18,14.7315789 18,16.3082707 L18,18 L10,18 L0,18 L0,15.9323308 C0,14.0052632 3.33571429,13.037594 5,13.037594 C6.66428571,13.037594 10,14.0052632 10,15.9323308 L10,16.3082707 Z M5.17857143,11.962406 C3.69642857,11.962406 2.5,10.8541353 2.5,9.48120301 C2.5,8.10827068 3.69642857,7 5.17857143,7 C6.66071429,7 7.84821429,8.10827068 7.84821429,9.48120301 C7.84821429,10.8541353 6.66071429,11.962406 5.17857143,11.962406 Z M14.1428571,13.0601504 C12.9571429,13.0601504 12,12.1533835 12,11.0300752 C12,9.90676692 12.9571429,9 14.1428571,9 C15.3285714,9 16.2785714,9.90676692 16.2785714,11.0300752 C16.2785714,12.1533835 15.3285714,13.0601504 14.1428571,13.0601504 Z"
                id="Combined-Shape"
                fill={color}
                className="icon-color"
            />
        </g>
    </svg>
);

Impersonate.propTypes = {
    color: PropTypes.string,
};

export default Impersonate;
